module.exports = __webpack_public_path__ + "img/icon-blank.f6db0fa2.svg";